const resStates = [ "delhi", "uttar pradesh", "haryana", "punjab", "chandigarh", "national capital territory of delhi", "new delhi", "uttarakhand" ]

export default resStates



// WEBPACK FOOTER //
// ./src/components/restrictedStates.js